import { useEffect, useState } from 'react';
import { useGetCustomers } from 'api/counterparties';
import {
  GetCustomerParams,
  Customer,
} from 'api/counterparties/counterparties.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function CustomerAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getCustomers } = useGetCustomers();
  const [options, setOptions] = useState<Customer[]>([]);
  const [customerParams, setCustomerParams] = useState<GetCustomerParams>({
    filterText: '',
    resultSize: 25,
    pageNumber: 1,
  });

  useEffect(() => {
    getCustomers(customerParams);
  }, [getCustomers, customerParams]);

  useEffect(() => {
    if (data?.length) {
      const filteredOptions = data.filter((customer) => {
        if (!customer.enabled) return false;
        const customerBusinessFunction = customer.businessFunctions?.find(
          (businessFunction) => businessFunction.__type === 'Customer',
        );
        return customerBusinessFunction?.enabled === true;
      });
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code || o.counterpartyShortName}
      handleSearchChange={handleChange(setOptions, setCustomerParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setCustomerParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setCustomerParams,
        formProps.field.onBlur,
      )}
    />
  );
}
